export const OWN_PRESENCE_ACTIONS = {
  SIGN_IN: 'sign_in',
  PAUSE: 'pause',
  RESUME: 'resume',
};

const ROSTER_STATUSES = new Set(['signed_up', 'active', 'paused']);

export function canShowOwnSessionPresence({
  isPegBoard = false,
  sessionStatus,
  rosterStatus,
  viewerPlayerId,
} = {}) {
  if (isPegBoard) return false;
  if (!viewerPlayerId) return false;
  if (sessionStatus !== 'ongoing') return false;
  return ROSTER_STATUSES.has(rosterStatus);
}

export function getOwnPresenceAction(rosterStatus) {
  if (rosterStatus === 'signed_up') return OWN_PRESENCE_ACTIONS.SIGN_IN;
  if (rosterStatus === 'paused') return OWN_PRESENCE_ACTIONS.RESUME;
  if (rosterStatus === 'active') return OWN_PRESENCE_ACTIONS.PAUSE;
  return null;
}

export function getOwnPresencePauseBlockReason({
  isOnCourt = false,
  isInUpcoming = false,
  scheduledGameId = null,
} = {}) {
  if (isOnCourt) {
    return 'You can pause after this game finishes. Or contact the host of the session to remove you from the game.';
  }
  if (isInUpcoming) {
    return 'You can pause after this upcoming game. Or contact the host of the session to remove you from the upcoming game.';
  }
  if (scheduledGameId) return 'Ask the host to change your scheduled game before you pause.';
  return null;
}

export function pausedIdsFromSessionStatus(sessionPlayerStatus = {}) {
  return Object.entries(sessionPlayerStatus)
    .filter(([, status]) => status === 'paused')
    .map(([playerId]) => playerId);
}

export function samePlayerIdList(left = [], right = []) {
  if (left.length !== right.length) return false;
  const rightSet = new Set(right);
  return left.every((id) => rightSet.has(id));
}

export function nextPresenceWaitingList(prev = [], playerId, status) {
  if (!playerId) return prev;
  if (status === 'active') {
    return prev.includes(playerId) ? prev : [...prev, playerId];
  }
  return prev.filter((id) => id !== playerId);
}

export function nextPresencePausedList(prev = [], playerId, status) {
  if (!playerId) return prev;
  if (status === 'paused') {
    return prev.includes(playerId) ? prev : [...prev, playerId];
  }
  return prev.filter((id) => id !== playerId);
}

export function latePenaltyNotice(penalty) {
  const value = Number(penalty) || 0;
  if (value <= 0) return null;
  const games = value === 1 ? '1 game' : `${value} games`;
  return `You have a late penalty of ${games}. Ask the host if you think this should be removed.`;
}
